/* Hushe custom cart drawer v2 - ATC feedback + upsells.
   Event-driven (no /cart.js polling: Shopify bot-protection 429s sessions that poll). */
(function(){
  if(!/mold-remover-gel/.test(location.pathname)) return;
  if(window.__hgDrawer) return; window.__hgDrawer=2;

  var rawFetch = window.fetch.bind(window);

  /* hgCapture — thu email trong cart drawer.
     TẮT tới 24/08/2026. Test giá đã HUỶ 05/08 — cửa sổ 02-22/08 ghi VÔ HIỆU.
     Bật = đổi HG_CAPTURE_ON thành true. */
  var HG_CAPTURE_ON   = false;
  var KL_COMPANY      = "RbbfsB";
  var KL_LIST         = "TRGsGB";

  var CSS=
  ".hgcd-cap{margin:14px 0 4px;padding:14px 15px;background:#f4f6f8;border-radius:10px;border:1px solid #e3e8ee}"+
  ".hgcd-cap h4{margin:0 0 5px;font-size:14px;font-weight:700;color:#112a42}"+
  ".hgcd-cap p{margin:0 0 10px;font-size:12.5px;line-height:1.5;color:#5a6672}"+
  ".hgcd-cap form{display:flex;gap:6px}"+
  ".hgcd-cap input{flex:1;min-width:0;padding:9px 11px;font-size:14px;border:1px solid #c9d2dc;border-radius:7px;background:#fff}"+
  ".hgcd-cap button{padding:9px 13px;font-size:13px;font-weight:700;border:0;border-radius:7px;background:#2f7fd3;color:#fff;cursor:pointer;white-space:nowrap}"+
  ".hgcd-cap button[disabled]{opacity:.55;cursor:default}"+
  ".hgcd-cap .hgcd-capmsg{margin:9px 0 0;font-size:12.5px;color:#1e7a46;font-weight:600}"+
  ".hgcd-cmp{display:flex;flex-wrap:wrap;align-items:center;gap:6px;margin:0 0 7px;font-size:13px;color:#1f4d36}"+
  ".hgcd-cmp s{color:#9aa39d;font-weight:400;margin-left:3px}.hgcd-arr{color:#b3261e;font-weight:800}"+
  ".hgcd-ov{position:fixed;inset:0;background:rgba(0,0,0,.45);opacity:0;visibility:hidden;transition:.25s;z-index:99998}"+
  ".hgcd-ov.open{opacity:1;visibility:visible}"+
  ".hgcd{position:fixed;top:0;right:0;height:100%;width:390px;max-width:92vw;background:#fff;box-shadow:-4px 0 28px rgba(0,0,0,.2);transform:translateX(106%);transition:transform .3s cubic-bezier(.4,0,.2,1);z-index:99999;display:flex;flex-direction:column;font-family:inherit}"+
  ".hgcd.open{transform:translateX(0)}"+
  ".hgcd-hd{display:flex;align-items:center;justify-content:space-between;padding:18px 20px;border-bottom:1px solid #eee}"+
  ".hgcd-ttl{font-weight:700;font-size:16.5px;color:#1f4d36;display:flex;align-items:center;gap:7px}"+
  ".hgcd-x{background:none;border:none;font-size:28px;line-height:1;cursor:pointer;color:#999;padding:0}"+
  ".hgcd-body{flex:1;overflow-y:auto;padding:16px 20px}"+
  ".hgcd-it{display:flex;gap:13px;margin-bottom:16px;align-items:flex-start}"+
  ".hgcd-img{width:66px;height:66px;object-fit:cover;border-radius:9px;background:#f4f4f4;flex-shrink:0}"+
  ".hgcd-nm{font-weight:600;font-size:14px;line-height:1.3;color:#222}"+
  ".hgcd-vr{font-size:12px;color:#8a8a8a;margin:3px 0}"+
  ".hgcd-qp{font-size:13px;color:#333;font-weight:500}"+
  ".hgcd-rm{background:none;border:none;color:#c4c4c4;font-size:22px;line-height:1;cursor:pointer;padding:0 2px;flex:0 0 auto}"+
  ".hgcd-rm:hover{color:#e0483a}.hgcd-rm[disabled]{opacity:.4}"+
  ".hgcd-ft{border-top:1px solid #eee;padding:16px 20px 20px}"+
  ".hgcd-sub{display:flex;justify-content:space-between;align-items:baseline;font-size:15px;margin-bottom:14px;color:#222}"+
  ".hgcd-sub b{font-size:18px}"+
  ".hgcd-ship{text-align:center;font-size:13px;color:#1f4d36;font-weight:600;margin:-4px 0 10px}"+
  ".hgcd-co{display:block;background:#1f4d36;color:#fff;text-align:center;padding:15px;border-radius:11px;font-weight:700;text-decoration:none;font-size:16px;letter-spacing:.3px}"+
  ".hgcd-co:hover{background:#163827}"+
  ".hgcd-row2{display:flex;gap:10px;margin-top:10px}"+
  ".hgcd-vc{flex:1;text-align:center;padding:11px;color:#1f4d36;text-decoration:none;font-size:13.5px;border:1px solid #cfe0d7;border-radius:9px;background:#f6faf8}"+
  ".hgcd-cont{flex:1;background:none;border:1px solid #e2e2e2;border-radius:9px;color:#777;padding:11px;cursor:pointer;font-size:13.5px}"+
  ".hgcd-trust{text-align:center;font-size:11.5px;color:#9a9a9a;margin-top:12px}"+
  ".hgcd-up{border:1.5px dashed #1f4d36;border-radius:11px;padding:13px 14px;margin:2px 0 14px;background:#f3f9f5}"+
  ".hgcd-uph{display:flex;gap:11px;align-items:center;margin-bottom:7px}"+
  ".hgcd-upimg{width:54px;height:54px;border-radius:9px;object-fit:contain;flex-shrink:0;background:#fff;border:1px solid #dce9e1;padding:3px;box-sizing:border-box}"+
  ".hgcd-up-t{font-weight:800;font-size:14.5px;color:#1f4d36;line-height:1.25}"+
  ".hgcd-up-d{font-size:12.5px;color:#4a6a58;line-height:1.45;margin-bottom:10px}"+
  ".hgcd-up-b{display:block;width:100%;background:#e8a33d;color:#1a1a1a;border:none;border-radius:9px;padding:12px;font-weight:800;font-size:14px;cursor:pointer}"+
  ".hgcd-up-b:hover{background:#d9922e}.hgcd-up-b[disabled]{opacity:.6;cursor:default}"+
  ".hgcd-add{display:block;width:100%;border:0;border-radius:9px;padding:11px;font-weight:800;font-size:14px;cursor:pointer;background:#e8a33d;color:#1a1a1a}"+
  ".hgcd-add.alt{background:#2d4a3a;color:#fff;font-weight:700}"+
  ".hgcd-add[disabled]{opacity:.6;cursor:default}"+
  ".hgcd-err{color:#c0392b;font-size:12px;margin-top:7px;text-align:center;font-weight:600}"+
  ".hgcd-mini{display:flex;align-items:center;gap:10px;border:1px solid #e3ece5;border-radius:10px;padding:9px 11px;margin:2px 0 14px;background:#fbfdfb}"+
  ".hgcd-mimg{width:40px;height:40px;border-radius:8px;object-fit:contain;background:#fff;border:1px solid #e4ede8;padding:2px;box-sizing:border-box;flex:0 0 auto}"+
  ".hgcd-mtx{flex:1;min-width:0;line-height:1.3}.hgcd-mtx b{font-size:13px;color:#1f4d36;display:block}.hgcd-mtx span{font-size:11.5px;color:#6b7d72}"+
  ".hgcd-madd{flex:0 0 auto;display:inline-block;width:auto;white-space:nowrap;background:#e8a33d;color:#1a1a1a;border:0;border-radius:8px;padding:8px 14px;font-weight:800;font-size:13px;cursor:pointer}"+
  ".hgcd-madd[disabled]{opacity:.6}";

  var st=document.createElement("style"); st.textContent=CSS; document.head.appendChild(st);

  var ov=document.createElement("div"); ov.className="hgcd-ov";
  var dr=document.createElement("div"); dr.className="hgcd";
  dr.innerHTML='<div class="hgcd-hd"><span class="hgcd-ttl">&#10003; Added to your cart</span><button class="hgcd-x" aria-label="Close">&times;</button></div><div class="hgcd-body"></div><div class="hgcd-ft"><div class="hgcd-sub"><span>Subtotal</span><b class="hgcd-tot"></b></div><div class="hgcd-ship">&#128666; Free tracked shipping &middot; arrives in 3&ndash;7 days</div><a class="hgcd-co" href="/checkout">Checkout &nbsp;&rarr;</a><div class="hgcd-row2"><a class="hgcd-vc" href="/cart">View cart</a><button class="hgcd-cont" type="button">Keep shopping</button></div><div class="hgcd-trust">&#128274; Secure checkout &middot; &#128154; 90-day money-back</div></div>';
  document.body.appendChild(ov); document.body.appendChild(dr);

  function close(){ dr.classList.remove("open"); ov.classList.remove("open"); }
  function open(){ dr.classList.add("open"); ov.classList.add("open"); }
  ov.addEventListener("click", close);
  dr.querySelector(".hgcd-x").addEventListener("click", close);
  dr.querySelector(".hgcd-cont").addEventListener("click", close);
  document.addEventListener("keydown", function(e){ if(e.key==="Escape") close(); });

  var GEL_SINGLE=48430787821753, GEL_TWIN=48321764720825, GEL_KIT=48430788509881,
      SCRUB=48321704722617, BRUSH=48321718911161,
      GEL_BIG=[48321764753593,48430788149433,48430788509881];
  var CDN="https://cdn.shopify.com/s/files/1/0716/9736/7202/files/";
  var IMG_GEL="https://cdn.shopify.com/s/files/1/0716/9736/7202/t/1/assets/hg-prodcard.png?v=1784386169",
      IMG_SCRUB=CDN+"4a1385b013ad691cbc007a9c351da141.png?v=1782274431&width=160",
      IMG_BRUSH=CDN+"1792759331335442432.jpg?v=1783653450&width=160";
  [IMG_GEL,IMG_SCRUB,IMG_BRUSH].forEach(function(u){ (new Image()).src=u; });

  function money(c){ return "$"+(c/100).toFixed(2); }
  function hgcdEv(n){ try{ if(window.clarity) window.clarity("event", n); }catch(x){} }
  var PRICES=null;   /* {s: single, t: twin, r: triple} in cents, from the live product JSON */
  rawFetch("/products/multi-surface-mold-remover-gel.js",{headers:{"Accept":"application/json"}}).then(getJSON).then(function(p){
    var m={}; (p.variants||[]).forEach(function(v){ m[v.id]=v.price; });
    PRICES={s:m[GEL_SINGLE], t:m[GEL_TWIN], r:m[GEL_BIG[0]]};
    if(dr.classList.contains("open")) refresh(false);   /* drawer opened before prices arrived: redraw with the offer */
  }).catch(function(){});
  function getJSON(r){
    if(!r.ok) throw new Error("HTTP "+r.status);
    return r.text().then(function(t){ return JSON.parse(t); });
  }
  function showErr(card,msg){
    var e=card.querySelector(".hgcd-err");
    if(!e){ e=document.createElement("div"); e.className="hgcd-err"; card.appendChild(e); }
    e.textContent=msg;
  }

  function card(img,title,body,btnHTML){
    var d=document.createElement("div"); d.className="hgcd-up";
    d.innerHTML='<div class="hgcd-uph"><img class="hgcd-upimg" src="'+img+'" alt=""><div class="hgcd-up-t">'+title+'</div></div><div class="hgcd-up-d">'+body+'</div>'+btnHTML;
    return d;
  }

  function render(cart){
    var b=dr.querySelector(".hgcd-body"); b.innerHTML="";
    cart.items.forEach(function(it){
      var img=it.image? (it.image.indexOf("//")===0? "https:"+it.image : it.image) : "";
      var row=document.createElement("div"); row.className="hgcd-it";
      row.innerHTML='<img class="hgcd-img" src="'+img+'" alt=""><div style="flex:1"><div class="hgcd-nm">'+it.product_title+'</div><div class="hgcd-vr">'+(it.variant_title||"")+'</div><div class="hgcd-qp">Qty '+it.quantity+" &middot; "+money(it.final_line_price)+'</div></div><button class="hgcd-rm" type="button" data-key="'+it.key+'" aria-label="Remove">&times;</button>';
      b.appendChild(row);
    });
    function lineQty(id){ var it=cart.items.filter(function(i){return i.id===id;})[0]; return it?it.quantity:0; }
    var ids=cart.items.map(function(i){return i.id;});
    var hasTwin=ids.indexOf(GEL_TWIN)>=0, hasBig=cart.items.some(function(i){return GEL_BIG.indexOf(i.id)>=0;});
    /* tier-upgrade swaps only make sense at qty 1 — at qty>1 the "+$20/+$15" claim would be wrong */
    /* Tier offers: every number is computed from the live variant prices (PRICES, loaded from the product JSON), so the
       copy stays true when the holiday sale ends and prices change. Clarity events: up2/up3 _seen / _click. */
    var P=PRICES||{};
    /* 2-3 single bottles (returning visitor whose old cart line gets +1, or a double tap): the same bottles cost less
       as the Twin/Triple pack, so offer a straight swap. data-q="1" = add ONE pack, not one per single. Events: sw2/sw3. */
    var qS=lineQty(GEL_SINGLE), swTo=qS===2?GEL_TWIN:GEL_BIG[0], swP=qS===2?P.t:P.r, swName=qS===2?"Twin Pack":"Triple Pack";
    if((qS===2||qS===3) && !hasTwin && !hasBig && P.s && swP && qS*P.s-swP>0){
      var swSave=qS*P.s-swP;
      b.appendChild(card(IMG_GEL,"&#128161; Same "+qS+" bottles, <b>"+money(swSave)+" less</b>",
        '<div class="hgcd-cmp"><span>'+qS+' singles <s>'+money(qS*P.s)+'</s></span><span class="hgcd-arr">&rarr;</span><span>'+swName+' <b>'+money(swP)+'</b></span></div>'+
        "You have "+qS+" single bottles in your cart. The "+swName+" is the same "+qS+" bottles for <b>"+money(swP)+"</b> ("+money(Math.round(swP/qS))+" each). Same <b>90-day money-back guarantee</b>.",
        '<button class="hgcd-up-b" type="button" data-ev="sw'+qS+'" data-q="1" data-busy="Switching…" data-from="'+GEL_SINGLE+'" data-to="'+swTo+'" data-lbl="Switch to '+swName+' &mdash; save '+money(swSave)+'">Switch to '+swName+' &mdash; save '+money(swSave)+'</button>'));
      hgcdEv("sw"+qS+"_seen");
    } else if(qS===1 && !hasTwin && !hasBig && P.s && P.t){
      var add2=P.t-P.s, each2=Math.round(P.t/2), save2=2*P.s-P.t;
      b.appendChild(card(IMG_GEL,"&#127873; Make it 2 &mdash; second bottle <b>"+money(add2)+"</b>",
        '<div class="hgcd-cmp"><span>1 bottle <b>'+money(P.s)+'</b></span><span class="hgcd-arr">&rarr;</span><span>2 bottles <b>'+money(P.t)+'</b> <s>'+money(2*P.s)+'</s></span></div>'+
        "<b>"+money(each2)+" each</b> instead of "+money(P.s)+" (save "+money(save2)+"). Keep one by the washer and one in the bathroom &mdash; or give one as a gift this holiday season. Both covered by the same <b>90-day money-back guarantee</b>.",
        '<button class="hgcd-up-b" type="button" data-ev="up2" data-from="'+GEL_SINGLE+'" data-to="'+GEL_TWIN+'" data-lbl="+ Add 2nd bottle &mdash; '+money(add2)+'">+ Add 2nd bottle &mdash; '+money(add2)+'</button>'));
      hgcdEv("up2_seen");
    } else if(lineQty(GEL_TWIN)===1 && ids.indexOf(GEL_SINGLE)<0 && !hasBig && P.t && P.r){
      var add3=P.r-P.t, each3=Math.round(P.r/3), save3=3*P.s-P.r;
      b.appendChild(card(IMG_GEL,"&#127873; Third bottle: <b>"+money(add3)+"</b>",
        "Lowest price per bottle &mdash; <b>"+money(each3)+" each</b> (save "+money(save3)+" vs three singles). One each for the washer, the fridge and the bathroom, or one to gift. All three covered by the same <b>90-day money-back guarantee</b>.",
        '<button class="hgcd-up-b" type="button" data-ev="up3" data-from="'+GEL_TWIN+'" data-to="'+GEL_BIG[0]+'" data-lbl="+ Add 3rd bottle &mdash; '+money(add3)+'">+ Add 3rd bottle &mdash; '+money(add3)+'</button>'));
      hgcdEv("up3_seen");
    }
    var hasGel=ids.indexOf(GEL_SINGLE)>=0||hasTwin||hasBig;
    var hasScrub=ids.indexOf(SCRUB)>=0||ids.indexOf(GEL_KIT)>=0;
    var hasBrush=ids.indexOf(BRUSH)>=0;
    if(false && hasGel && !hasBrush){ /* HG: brush cross-sell TAM TAT - doi false->true de bat lai */
      /* compact one-line row: brush attach is in-band (~7%) — keep, but don't compete with the tier card */
      var br=document.createElement("div"); br.className="hgcd-mini";
      br.innerHTML='<img class="hgcd-mimg" src="'+IMG_BRUSH+'" alt=""><div class="hgcd-mtx"><b>360° Detail Brush Set</b><span>Reaches grout lines the gel can’t &middot; $19.99</span></div><button class="hgcd-madd hgcd-add" type="button" data-id="'+BRUSH+'" data-lbl="+ Add">+ Add</button>';
      b.appendChild(br);
    }
    if(HG_CAPTURE_ON && !localStorage.getItem("hgCapDone")){
      var cap=document.createElement("div"); cap.className="hgcd-cap";
      cap.innerHTML='<h4>Get the 3-step method by email</h4>'+
        '<p>The two-minute guide that lifts mold stains on the first try, plus care tips for grout and seals. No spam &mdash; unsubscribe any time.</p>'+
        '<form novalidate><input type="email" required placeholder="you@example.com" aria-label="Email address" autocomplete="email"><button type="submit">Send it</button></form>';
      cap.querySelector("form").addEventListener("submit",function(e){
        e.preventDefault();
        var f=e.currentTarget, inp=f.querySelector("input"), btn=f.querySelector("button");
        var em=(inp.value||"").trim();
        if(!/^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(em)){ inp.focus(); return; }
        btn.disabled=true; btn.textContent="Sending\u2026";
        rawFetch("https://a.klaviyo.com/client/subscriptions/?company_id="+KL_COMPANY,{
          method:"POST",
          headers:{"revision":"2025-07-15","content-type":"application/json"},
          body:JSON.stringify({data:{type:"subscription",
            attributes:{profile:{data:{type:"profile",attributes:{email:em}}}},
            relationships:{list:{data:{type:"list",id:KL_LIST}}}}})
        }).then(function(r){
          if(r.status>=200 && r.status<300){
            try{ localStorage.setItem("hgCapDone","1"); }catch(x){}
            cap.innerHTML='<h4>Check your inbox</h4><p class="hgcd-capmsg">The guide is on its way to '+em.replace(/[<>&]/g,"")+'.</p>';
          } else { btn.disabled=false; btn.textContent="Try again"; }
        }).catch(function(){ btn.disabled=false; btn.textContent="Try again"; });
      });
      b.appendChild(cap);
    }
    dr.querySelector(".hgcd-tot").textContent=money(cart.total_price);
  }

  function refresh(openAfter,attempt){
    rawFetch("/cart.js",{cache:"no-store",headers:{"Accept":"application/json"}})
      .then(getJSON)
      .then(function(c){ render(c); if(openAfter) open(); })
      .catch(function(){ if(!attempt) setTimeout(function(){ refresh(openAfter,1); },1600); });
  }
  var rt=null;
  function queueRefresh(openAfter){ clearTimeout(rt); rt=setTimeout(function(){ refresh(openAfter); },250); }

  /* Detect the theme's own add-to-cart (fetch + XHR + form fallback) — replaces polling. */
  window.fetch=function(input,init){
    var url=(typeof input==="string")?input:((input&&input.url)||"");
    var p=rawFetch(input,init);
    if(/\/cart\/add/.test(url)){ p.then(function(r){ if(r.ok) queueRefresh(true); },function(){}); }
    return p;
  };
  var XO=XMLHttpRequest.prototype.open, XS=XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open=function(m,u){ this.__hgU=u; return XO.apply(this,arguments); };
  XMLHttpRequest.prototype.send=function(){
    var x=this;
    if(/\/cart\/add/.test(x.__hgU||"")){ x.addEventListener("load",function(){ if(x.status>=200&&x.status<300) queueRefresh(true); }); }
    return XS.apply(this,arguments);
  };
  document.addEventListener("submit",function(e){
    var f=e.target;
    if(f && /\/cart\/add/.test(f.getAttribute("action")||"")) setTimeout(function(){ queueRefresh(true); },1200);
  },true);

  /* Tier upgrade: swap FROM -> TO, only removing FROM after the add succeeded. */
  dr.addEventListener("click", function(e){
    var btn=e.target.closest(".hgcd-up-b"); if(!btn) return;
    hgcdEv((btn.getAttribute("data-ev")||"up")+"_click");
    var FROM=+btn.getAttribute("data-from"), TO=+btn.getAttribute("data-to"),
        LBL=btn.getAttribute("data-lbl")||btn.textContent, cardEl=btn.closest(".hgcd-up");
    btn.disabled=true; btn.textContent=btn.getAttribute("data-busy")||"Adding…";
    rawFetch("/cart.js",{cache:"no-store",headers:{"Accept":"application/json"}}).then(getJSON).then(function(c){
      var s=c.items.filter(function(i){return i.id===FROM;})[0]; var q=btn.hasAttribute("data-q")? +btn.getAttribute("data-q") : (s?s.quantity:1);
      return rawFetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json","Accept":"application/json"},body:JSON.stringify({id:TO,quantity:q,properties:{"_source":"drawer-upgrade"}})})
        .then(getJSON)
        .then(function(){ var u={}; u[FROM]=0; return rawFetch("/cart/update.js",{method:"POST",headers:{"Content-Type":"application/json","Accept":"application/json"},body:JSON.stringify({updates:u})}).then(getJSON); });
    }).then(function(c){ render(c); })
      .catch(function(){ btn.disabled=false; btn.innerHTML=LBL; if(cardEl) showErr(cardEl,"Couldn’t add — please tap again."); });
  });

  /* Cross-sell add + line-item remove. */
  document.addEventListener("click",function(e){
    var rb=e.target.closest(".hgcd-rm");
    if(rb){
      var k=rb.getAttribute("data-key"); rb.disabled=true;
      rawFetch("/cart/change.js",{method:"POST",headers:{"Content-Type":"application/json","Accept":"application/json"},body:JSON.stringify({id:k,quantity:0})})
        .then(getJSON).then(function(c){ render(c); })
        .catch(function(){ rb.disabled=false; });
      return;
    }
    var btn=e.target.closest(".hgcd-add"); if(!btn) return;
    var LBL=btn.getAttribute("data-lbl")||"+ Add", cardEl=btn.closest(".hgcd-up");
    btn.disabled=true; btn.textContent="Adding…";
    rawFetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json","Accept":"application/json"},body:JSON.stringify({id:+btn.getAttribute("data-id"),quantity:1,properties:{"_source":"drawer-add"}})})
      .then(getJSON)
      .then(function(){ return rawFetch("/cart.js",{cache:"no-store",headers:{"Accept":"application/json"}}).then(getJSON); })
      .then(function(c){ render(c); })
      .catch(function(){ btn.disabled=false; btn.innerHTML=LBL; if(cardEl) showErr(cardEl,"Couldn’t add — please tap again."); });
  });
})();
